import { nanoid } from 'nanoid';

import { BuiltInComponents } from 'craft/constants';
import {
  CssSelectorDefinitions,
  CssSelectorId,
  CssSelectorType,
  HANDLER_TYPES,
  INTERACTION_TYPES,
  SerializedNodeTree,
  TRIGGERS,
} from 'craft/types';

const HOTSPOT_TITLE = 'Say hello to your first Hotspot';
const HOTSPOT_DESCRIPTION = 'Add some descriptive text here.';

interface Props {
  contentName: string;
}

export const getFirstHotspot = ({ contentName }: Props) =>
  (({
    rootNodeId: '2bBlLh',
    nodes: {
      '2bBlLh': {
        type: {
          resolvedName: BuiltInComponents.Hotspot,
        },
        props: {
          stateId: nanoid(6),
          dismissBehaviour: 'dismiss',
        },
        name: 'Hotspot',
        custom: {
          actions: [
            {
              eventName: `Dismissed Hotspot ${contentName}`,
              category: INTERACTION_TYPES.Dismiss,
            },
          ],
          cssSelectors: {
            [CssSelectorId.HotspotBody]: {
              selector: CssSelectorDefinitions[CssSelectorId.HotspotBody].selector,
              type: CssSelectorType.HTML,
              css: {
                width: '300px',
              },
            },
          },
        },
        nodes: ['3E6PAG', '15pe2l'],
      },
      '3E6PAG': {
        type: {
          resolvedName: BuiltInComponents.RichTextEditor,
        },
        name: 'RichText',
        parent: '2bBlLh',
        props: {},
        nodes: ['43dVfQ', '4gnwVC'],
      },
      '43dVfQ': {
        type: {
          resolvedName: BuiltInComponents.Typography,
        },
        name: 'Typography',
        props: {},
        custom: {
          custom: {
            variant: 'P',
            variation: 'base',
          },
          css: {
            fontSize: '16px',
            marginTop: '0px',
            marginBottom: '4px',
          },
        },
        parent: '3E6PAG',
        nodes: ['3zwvdV'],
      },
      '3zwvdV': {
        type: {
          resolvedName: BuiltInComponents.Text,
        },
        props: {
          childrenString: HOTSPOT_TITLE,
        },
        name: 'Text',
        custom: {
          custom: {
            marks: ['B'],
          },
        },
        parent: '43dVfQ',
      },
      '4gnwVC': {
        type: {
          resolvedName: BuiltInComponents.Typography,
        },
        name: 'Typography',
        props: {},
        custom: {
          custom: {
            variant: 'P',
            variation: 'base',
          },
          css: {
            marginTop: '0px',
            marginBottom: '16px',
          },
        },
        parent: '3E6PAG',
        nodes: ['19yjT'],
      },
      '19yjT': {
        type: {
          resolvedName: BuiltInComponents.Text,
        },
        props: {
          childrenString: HOTSPOT_DESCRIPTION,
        },
        name: 'Text',
        parent: '4gnwVC',
      },
      '15pe2l': {
        type: {
          resolvedName: BuiltInComponents.Button,
        },
        custom: {
          actions: [
            {
              trigger: TRIGGERS.ON_CLICK,
              handler: {
                type: HANDLER_TYPES.DISMISS_HOTSPOT_GROUP,
              },
              eventName: 'Hotspot Group Dismissed',
              category: 'Native',
            },
          ],
        },
        props: {
          outline: 'solid',
          size: 'md',
          color: 'primary',
          childrenString: 'Dismiss all',
          variant: 'base',
        },
        name: 'Button',
        parent: '2bBlLh',
      },
    },
  } as unknown) as SerializedNodeTree);
